<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <SpecieForm :baseSpecie="specie" :basespecieName="name" :loading="loading" @submit-requested="submitRequested"></SpecieForm>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import SpecieForm from './SpecieForm.vue'
    import router from '@/router';

    export default {
        data() {
            return {
                specie: null,
                name: this.$route.params.name,
                loading: true
            }
        },
        components: { SpecieForm },
        computed:
        {
            ...mapState('species', ['getSpecieByIdOutput']),
        },
        methods: {
            ...mapActions('species', ['getSpecieById']),
            ...mapActions('species', ['putSpecie']),
            submitRequested(specie) {
                this.putSpecie(specie);
            },
        },
        mounted: function () {
            if (!this.$route.query.id) {
                router.push({ path: '/species/list' });
            }
            else {
                this.getSpecieById(this.$route.query.id);
            }
        },
        watch:
        {
            getSpecieByIdOutput: function (output) {
                if (!output) {
                    router.push({ path: '/species/list' });
                }
                else {
                    this.specie = output;
                    this.loading = false;
                }
            }
        }
    }
</script>